import { useState } from "react";
import { CalendarDays } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";
import { Calendar } from "./ui/calendar";
import { fmtDate } from "../lib/api";

const toLocal = (s) => (s ? new Date(`${s}T00:00:00`) : undefined);
const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export default function DateField({ value, onChange, min, max, testid, className = "" }) {
  const [open, setOpen] = useState(false);
  const disabled = [min && { before: toLocal(min) }, max && { after: toLocal(max) }].filter(Boolean);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className={`input flex items-center justify-between gap-2 text-left ${className}`} data-testid={testid}>
          <span className={value ? "text-slate-900" : "text-slate-400"}>{value ? fmtDate(value) : "dd/mm/yyyy"}</span><CalendarDays size={16} className="text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" weekStartsOn={1} selected={toLocal(value)} defaultMonth={toLocal(value) || toLocal(min)} disabled={disabled}
          onSelect={(d) => { if (d) { onChange(ymd(d)); setOpen(false); } }} />
      </PopoverContent>
    </Popover>
  );
}
